import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, HostListener, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
@Component({
  selector: 'app-resizable-draggable-b-text',
  templateUrl: './resizable-draggable-b-text.component.html',
  styleUrls: ['./resizable-draggable-b-text.component.scss']
})

export class ResizableDraggableBTextComponent implements OnInit, OnChanges, AfterViewInit {
  @Input('part') public part: any;
  @Input('host') public host: any;
  @Input('tracks') public tracks: any;
  @Input('project') public project: any;
  @Input('verticalLine') public verticalLine: any;
  @Input('isProjectPlaying') public isProjectPlaying: any;
  @Input('currentTimeProject') public currentTimeProject: any;
  @Input('currentCutTimeProject') public currentCutTimeProject: any;
  @Input('company_id') public company_id: any;
  @Input('subSets') public subSets: any;
  @Input('holst') public holst: any;
  @Input('height') public height: any;
  @Input('width') public width: any;
  resizerDraw: Function;
  resizer: Function;
  // resizeDirection: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight' | null = null;

  public isMagnetActive = {
    centerV: false,
    centerH: false,
    top: false,
    bottom: false,
    left: false,
    right: false
  };

  private readonly MAGNET_RANGE = 2.5;
  
  ngOnInit() {

  }

  ngAfterViewInit(): void {
  }

  partSubSet(part) {
    return !!this.subSets ? this.subSets.find(x => x.id == part.subSetID) : null
  }

  saveTextDrawPosition() {
    this.part.settings.pos.perc = {
      x: (this.part.settings.pos.x / this.project.width)*100,
      y: (this.part.settings.pos.y / this.project.height)*100,
      px: (this.part.settings.pos.px / this.project.width)*100,
      py: (this.part.settings.pos.py / this.project.height)*100,
      width: (this.part.settings.pos.width / this.project.width)*100,
      height: (this.part.settings.pos.height / this.project.height)*100,
    }
  }

  useSpeedRate(val, element) {
    return (val*(1/element.part_speed_rate)).toFixed(6)
  }

  shouldApplyHeight(ind, array) {
    if (ind === 0) return false;

    return array[ind - 1].value === '#n#' || array[ind - 1].value === '';
  }

  loadTextDrawPosition() {
    if (!this.part) {
      return
    }
    this.part.settings.pos.x = Math.ceil((this.part.settings.pos.perc.x / 100)*this.project.width);
    this.part.settings.pos.y = Math.ceil((this.part.settings.pos.perc.y / 100)*this.project.height);
    this.part.settings.pos.px = Math.ceil((this.part.settings.pos.perc.px / 100)*this.project.width);
    this.part.settings.pos.py = Math.ceil((this.part.settings.pos.perc.py / 100)*this.project.height);
    this.part.settings.pos.width = Math.ceil((this.part.settings.pos.perc.width / 100)*this.project.width);
    this.part.settings.pos.height = Math.ceil((this.part.settings.pos.perc.height / 100)*this.project.height);
  }

  saveSubPosition() {
    
    let partSubSet = this.partSubSet(this.part);
    if (!partSubSet || !partSubSet.pos) {
      return
    }
    partSubSet.pos.perc = {
      x: (partSubSet.pos.x / this.project.width)*100,
      y: (partSubSet.pos.y / this.project.height)*100,
      px: (partSubSet.pos.px / this.project.width)*100,
      py: (partSubSet.pos.py / this.project.height)*100,
      width: (partSubSet.pos.width / this.project.width)*100,
      height: (partSubSet.pos.height / this.project.height)*100,
    }
  }

  loadSubPosition() {
    let partSubSet = this.partSubSet(this.part);
    if (!partSubSet || !partSubSet.pos || !partSubSet.pos.perc) {
      return
    }
    partSubSet.pos.x = Math.ceil((partSubSet.pos.perc.x / 100)*this.project.width);
    partSubSet.pos.y = Math.ceil((partSubSet.pos.perc.y / 100)*this.project.height);
    partSubSet.pos.px = Math.ceil((partSubSet.pos.perc.px / 100)*this.project.width);
    partSubSet.pos.py = Math.ceil((partSubSet.pos.perc.py / 100)*this.project.height);
    partSubSet.pos.width = Math.ceil((partSubSet.pos.perc.width / 100)*this.project.width);
    partSubSet.pos.height = Math.ceil((partSubSet.pos.perc.height / 100)*this.project.height);
  }

  
  onWindowPress(event: MouseEvent) {
    if (!this.part.crop_on) {
      return
    }
    let partSubSet = this.partSubSet(this.part);
    partSubSet.pos.draggingWindow = true;
    partSubSet.pos.px = event.clientX;
    partSubSet.pos.py = event.clientY;
    this.saveSubPosition();
  }

  onWindowDrag(event: MouseEvent) {
    if (!this.part.crop_on) {
      return
    }
    let partSubSet = this.partSubSet(this.part);
    if (!partSubSet.pos.draggingWindow) {
      return;
    }
    let offsetX = event.clientX - partSubSet.pos.px;
    let offsetY = event.clientY - partSubSet.pos.py;

    partSubSet.pos.x += offsetX;
    partSubSet.pos.y += offsetY;
    partSubSet.pos.px = event.clientX;
    partSubSet.pos.py = event.clientY;
    this.updateMagnetLinesAndSnapOnMove();
    this.saveSubPosition();
  }

  private updateMagnetLinesAndSnapOnMove() {
    console.log("updateMagnetLinesAndSnapOnMove")
    let partSubSet = this.partSubSet(this.part);

    let l = partSubSet.pos.x;
    let t = partSubSet.pos.y;
    let w = partSubSet.pos.width;
    let h = partSubSet.pos.height;

    let r = l + w;
    let b = t + h;
    let centerX = l + w / 2;
    let centerY = t + h / 2;

    // К координатам project
    let pw = this.project.width;
    let ph = this.project.height;

    // Сброс
    this.isMagnetActive.centerV = false;
    this.isMagnetActive.centerH = false;
    this.isMagnetActive.left = false;
    this.isMagnetActive.right = false;
    this.isMagnetActive.top = false;
    this.isMagnetActive.bottom = false;

    // Вертикаль - центр project
    if (Math.abs(centerX - pw / 2) <= this.MAGNET_RANGE) {
      this.isMagnetActive.centerV = true;
     partSubSet.pos.x += (pw / 2 - centerX);
      l =partSubSet.pos.x; centerX = l + w / 2; // обновить после snap
    }
    // Горизонталь - центр
    if (Math.abs(centerY - ph / 2) <= this.MAGNET_RANGE) {
      this.isMagnetActive.centerH = true;
     partSubSet.pos.y += (ph / 2 - centerY);
      t =partSubSet.pos.y; centerY = t + h / 2;
    }
    // Левый край
    if (Math.abs(l - 0) <= this.MAGNET_RANGE) {
      this.isMagnetActive.left = true;
     partSubSet.pos.x = 0;
      l = 0;
    }
    // Правый край
    if (Math.abs((l + w) - pw) <= this.MAGNET_RANGE) {
      this.isMagnetActive.right = true;
     partSubSet.pos.x = pw - w;
      l =partSubSet.pos.x;
    }
    // Верхний край
    if (Math.abs(t - 0) <= this.MAGNET_RANGE) {
      this.isMagnetActive.top = true;
     partSubSet.pos.y = 0;
      t = 0;
    }
    // Нижний край
    if (Math.abs((t + h) - ph) <= this.MAGNET_RANGE) {
      this.isMagnetActive.bottom = true;
     partSubSet.pos.y = ph - h;
      t =partSubSet.pos.y;
    }
  }

  topLeftResize(offsetX: number, offsetY: number) {
    let partSubSet = this.partSubSet(this.part);
    partSubSet.pos.x += offsetX;
    partSubSet.pos.y += offsetY;
    partSubSet.pos.width -= offsetX;
    partSubSet.pos.height -= offsetY;
  }

  topRightResize(offsetX: number, offsetY: number) {
    let partSubSet = this.partSubSet(this.part);
    partSubSet.pos.y += offsetY;
    partSubSet.pos.width += offsetX;
    partSubSet.pos.height -= offsetY;
  }

  bottomLeftResize(offsetX: number, offsetY: number) {
    console.log('bottomLeftResize', offsetX, offsetY);
    let partSubSet = this.partSubSet(this.part);
    console.log('bottomLeftResize', partSubSet);
    partSubSet.pos.x += offsetX;
    partSubSet.pos.width -= offsetX;
    partSubSet.pos.height += offsetY;
  }

  bottomRightResize(offsetX: number, offsetY: number) {
    let partSubSet = this.partSubSet(this.part);
    partSubSet.pos.width += offsetX;
    partSubSet.pos.height += offsetY;
  }

  onCornerClick(event: MouseEvent, direction: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight') {
    const partSubSet = this.partSubSet(this.part);
    if (!partSubSet) return;

    partSubSet.pos.draggingCorner = true;
    partSubSet.pos.px = event.clientX;
    partSubSet.pos.py = event.clientY;

    partSubSet.pos.resizeDirection = direction;

    event.preventDefault();
    event.stopPropagation();
    this.saveSubPosition();
  }

  // textDraw start
  onWindowPressDraw(event: MouseEvent) {
    console.log("w1");
    console.log("w1", this.part);
    this.part.settings.pos.draggingWindow = true;
    this.part.settings.pos.px = event.clientX;
    this.part.settings.pos.py = event.clientY;
    this.saveTextDrawPosition();
  }

  onWindowDragDraw(event: MouseEvent) {
    if (!this.part) return;
    if (this.part.settings.pos.resizing) return;
    if (!this.part.settings.pos.draggingWindow) return;

    let offsetX = event.clientX - this.part.settings.pos.px;
    let offsetY = event.clientY - this.part.settings.pos.py;

    this.part.settings.pos.x += offsetX;
    this.part.settings.pos.y += offsetY;
    this.part.settings.pos.px = event.clientX;
    this.part.settings.pos.py = event.clientY;
    this.updateMagnetLinesAndSnapOnMoveDraw()
    this.saveTextDrawPosition();
  }


  private updateMagnetLinesAndSnapOnMoveDraw() {
    let l = this.part.settings.pos.x;
    let t = this.part.settings.pos.y;
    let w = this.part.settings.pos.width;
    let h = this.part.settings.pos.height;

    let r = l + w;
    let b = t + h;
    let centerX = l + w / 2;
    let centerY = t + h / 2;

    // К координатам project
    let pw = this.project.width;
    let ph = this.project.height;

    // Сброс
    this.isMagnetActive.centerV = false;
    this.isMagnetActive.centerH = false;
    this.isMagnetActive.left = false;
    this.isMagnetActive.right = false;
    this.isMagnetActive.top = false;
    this.isMagnetActive.bottom = false;

    // Вертикаль - центр project
    if (Math.abs(centerX - pw / 2) <= this.MAGNET_RANGE) {
      this.isMagnetActive.centerV = true;
      this.part.settings.pos.x += (pw / 2 - centerX);
      l = this.part.settings.pos.x; centerX = l + w / 2; // обновить после snap
    }
    // Горизонталь - центр
    if (Math.abs(centerY - ph / 2) <= this.MAGNET_RANGE) {
      this.isMagnetActive.centerH = true;
      this.part.settings.pos.y += (ph / 2 - centerY);
      t = this.part.settings.pos.y; centerY = t + h / 2;
    }
    // Левый край
    if (Math.abs(l - 0) <= this.MAGNET_RANGE) {
      this.isMagnetActive.left = true;
      this.part.settings.pos.x = 0;
      l = 0;
    }
    // Правый край
    if (Math.abs((l + w) - pw) <= this.MAGNET_RANGE) {
      this.isMagnetActive.right = true;
      this.part.settings.pos.x = pw - w;
      l = this.part.settings.pos.x;
    }
    // Верхний край
    if (Math.abs(t - 0) <= this.MAGNET_RANGE) {
      this.isMagnetActive.top = true;
      this.part.settings.pos.y = 0;
      t = 0;
    }
    // Нижний край
    if (Math.abs((t + h) - ph) <= this.MAGNET_RANGE) {
      this.isMagnetActive.bottom = true;
      this.part.settings.pos.y = ph - h;
      t = this.part.settings.pos.y;
    }
  }

  private updateMagnetLinesAndSnapOnResizeDraw(corner: 'topLeft'|'topRight'|'bottomLeft'|'bottomRight') {
    let l = this.part.settings.pos.x;
    let t = this.part.settings.pos.y;
    let w = this.part.settings.pos.width;
    let h = this.part.settings.pos.height;
    let r = l + w;
    let b = t + h;
    let pw = this.project.width;
    let ph = this.project.height;
    const m = this.isMagnetActive;

    // Сброс
    m.left = m.right = m.top = m.bottom = m.centerV = m.centerH = false;

    let centerX = l + w/2;
    let centerY = t + h/2;

    // Магнит к КРАЯМ
    if ((corner === 'topLeft' || corner === 'bottomLeft') && Math.abs(l - 0) <= this.MAGNET_RANGE) {
      m.left = true;
      this.part.settings.pos.x = 0;
      w = r - 0;
      centerX = 0 + w/2;
    }
    if ((corner === 'topRight' || corner === 'bottomRight') && Math.abs(r - pw) <= this.MAGNET_RANGE) {
      m.right = true;
      this.part.settings.pos.width = pw - l;
      w = this.part.settings.pos.width;
      centerX = l + w/2;
    }
    if ((corner === 'topLeft' || corner === 'topRight') && Math.abs(t - 0) <= this.MAGNET_RANGE) {
      m.top = true;
      this.part.settings.pos.y = 0;
      h = b - 0;
      centerY = 0 + h/2;
    }
    if ((corner === 'bottomLeft' || corner === 'bottomRight') && Math.abs(b - ph) <= this.MAGNET_RANGE) {
      m.bottom = true;
      this.part.settings.pos.height = ph - t;
      h = this.part.settings.pos.height;
      centerY = t + h/2;
    }

    // МАГНИТ К ЦЕНТРУ по X (вертикальная линия)
    // left-ручки: меняем x и width; right-ручки: меняем width
    if (Math.abs(centerX - pw/2) <= this.MAGNET_RANGE) {
      m.centerV = true;
      if (corner === 'topRight' || corner === 'bottomRight') {
        this.part.settings.pos.width = 2 * (pw/2 - l);
        w = this.part.settings.pos.width; centerX = l + w/2;
      }
      if (corner === 'topLeft' || corner === 'bottomLeft') {
        let newLeft = pw/2 - w/2;
        this.part.settings.pos.x = newLeft;
        this.part.settings.pos.width = r - newLeft;
        l = newLeft; w = this.part.settings.pos.width; centerX = l + w/2;
      }
    }

    // МАГНИТ К ЦЕНТРУ по Y (горизонтальная линия)
    if (Math.abs(centerY - ph/2) <= this.MAGNET_RANGE) {
      m.centerH = true;
      if (corner === 'bottomLeft' || corner === 'bottomRight') {
        this.part.settings.pos.height = 2 * (ph/2 - t);
        h = this.part.settings.pos.height; centerY = t + h/2;
      }

      if (corner === 'topLeft' || corner === 'topRight') {
        // Нижняя граница фиксирована, сдвигаем верх!
        let newTop = ph/2 - h/2;
        this.part.settings.pos.y = newTop;
        this.part.settings.pos.height = b - newTop;
        t = newTop; h = this.part.settings.pos.height; centerY = t + h/2;
      }
    }
  }

  topLeftResizeDraw(offsetX: number, offsetY: number) {
    if (!this.part) {
      return
    }
    this.part.settings.pos.x += offsetX;
    this.part.settings.pos.y += offsetY;
    this.part.settings.pos.width -= offsetX;
    this.part.settings.pos.height -= offsetY;
    this.updateMagnetLinesAndSnapOnResizeDraw("topLeft");
  }

  topRightResizeDraw(offsetX: number, offsetY: number) {
    if (!this.part) {
      return
    }
    this.part.settings.pos.y += offsetY;
    this.part.settings.pos.width += offsetX;
    this.part.settings.pos.height -= offsetY;
    this.updateMagnetLinesAndSnapOnResizeDraw("topRight");
  }

  bottomLeftResizeDraw(offsetX: number, offsetY: number) {
    if (!this.part) {
      return
    }
    this.part.settings.pos.x += offsetX;
    this.part.settings.pos.width -= offsetX;
    this.part.settings.pos.height += offsetY;
    this.updateMagnetLinesAndSnapOnResizeDraw("bottomLeft");
  }

  bottomRightResizeDraw(offsetX: number, offsetY: number) {
    if (!this.part) {
      return
    }
    this.part.settings.pos.width += offsetX;
    this.part.settings.pos.height += offsetY;
    this.updateMagnetLinesAndSnapOnResizeDraw("bottomRight");
  }

  toggleTextDrawChange(e) {
    e.preventDefault();
    e.stopPropagation();
    console.log("w2")


    if (!!this.part.settings.pos.is_edited) {
      let parts = (this.tracks.filter(x => x.type == 'text').map(k => k.parts) as any).flat(Infinity)
      parts.forEach(part => {
        part.settings.pos.is_edited = false;
      })
    } else {
      let parts = (this.tracks.filter(x => x.type == 'text').map(k => k.parts) as any).flat(Infinity)
      parts.forEach(part => {
        part.settings.pos.is_edited = false;
      })
      this.part.settings.pos.is_edited = true;
    }

    console.log("w22", this.part);
  }

  toggleSubChange(e) {
    e.preventDefault();
    e.stopPropagation();
    console.log("w2")


    if (!!this.part.crop_on) {
      let parts = (this.tracks.filter(x => x.type == 'sub').map(k => k.parts) as any).flat(Infinity)
      parts.forEach(part => {
        part.crop_on = false;
      })
    } else {
      let parts = (this.tracks.filter(x => x.type == 'sub').map(k => k.parts) as any).flat(Infinity)
      parts.forEach(part => {
        part.crop_on = false;
      })
      this.part.crop_on = true;
    }

    console.log("w22", this.part);
  }

  onCornerClickDraw(event: MouseEvent, resizerDraw?: Function) {
    this.part.settings.pos.draggingCorner = true;
    this.part.settings.pos.px = event.clientX;
    this.part.settings.pos.py = event.clientY;
    this.resizerDraw = resizerDraw;
    event.preventDefault();
    event.stopPropagation();
    this.saveTextDrawPosition();
  }

  private updateMagnetLinesAndSnapOnResizeSub(corner: 'topLeft'|'topRight'|'bottomLeft'|'bottomRight') {
    let partSubSet = this.partSubSet(this.part);

    let l = partSubSet.pos.x;
    let t = partSubSet.pos.y;
    let w = partSubSet.pos.width;
    let h = partSubSet.pos.height;
    let r = l + w;
    let b = t + h;
    let pw = this.project.width;
    let ph = this.project.height;
    const m = this.isMagnetActive;

    // Сброс
    m.left = m.right = m.top = m.bottom = m.centerV = m.centerH = false;

    let centerX = l + w/2;
    let centerY = t + h/2;

    // Магнит к КРАЯМ
    if ((corner === 'topLeft' || corner === 'bottomLeft') && Math.abs(l - 0) <= this.MAGNET_RANGE) {
      m.left = true;
      partSubSet.pos.x = 0;
      w = r - 0;
      centerX = 0 + w/2;
    }
    if ((corner === 'topRight' || corner === 'bottomRight') && Math.abs(r - pw) <= this.MAGNET_RANGE) {
      m.right = true;
      partSubSet.pos.width = pw - l;
      w = partSubSet.pos.width;
      centerX = l + w/2;
    }
    if ((corner === 'topLeft' || corner === 'topRight') && Math.abs(t - 0) <= this.MAGNET_RANGE) {
      m.top = true;
      partSubSet.pos.y = 0;
      h = b - 0;
      centerY = 0 + h/2;
    }
    if ((corner === 'bottomLeft' || corner === 'bottomRight') && Math.abs(b - ph) <= this.MAGNET_RANGE) {
      m.bottom = true;
      partSubSet.pos.height = ph - t;
      h = partSubSet.pos.height;
      centerY = t + h/2;
    }

    // МАГНИТ К ЦЕНТРУ по X (вертикальная линия)
    // left-ручки: меняем x и width; right-ручки: меняем width
    if (Math.abs(centerX - pw/2) <= this.MAGNET_RANGE) {
      m.centerV = true;
      if (corner === 'topRight' || corner === 'bottomRight') {
        partSubSet.pos.width = 2 * (pw/2 - l);
        w = partSubSet.pos.width; centerX = l + w/2;
      }
      if (corner === 'topLeft' || corner === 'bottomLeft') {
        let newLeft = pw/2 - w/2;
        partSubSet.pos.x = newLeft;
        partSubSet.pos.width = r - newLeft;
        l = newLeft; w = partSubSet.pos.width; centerX = l + w/2;
      }
    }

    // МАГНИТ К ЦЕНТРУ по Y (горизонтальная линия)
    if (Math.abs(centerY - ph/2) <= this.MAGNET_RANGE) {
      m.centerH = true;
      if (corner === 'bottomLeft' || corner === 'bottomRight') {
        partSubSet.pos.height = 2 * (ph/2 - t);
        h = partSubSet.pos.height; centerY = t + h/2;
      }

      if (corner === 'topLeft' || corner === 'topRight') {
        // Нижняя граница фиксирована, сдвигаем верх!
        let newTop = ph/2 - h/2;
        partSubSet.pos.y = newTop;
        partSubSet.pos.height = b - newTop;
        t = newTop; h = partSubSet.pos.height; centerY = t + h/2;
      }
    }
  }


  @HostListener('document:mousemove', ['$event'])
  onCornerMove(event: MouseEvent) {
      if (!this.part) return;

      if (this.part.type == 'text' && this.part.settings?.pos?.draggingCorner) {
        let offsetX = event.clientX - this.part.settings.pos.px;
        let offsetY = event.clientY - this.part.settings.pos.py;
    
        if (this.resizerDraw) {
            this.resizerDraw(offsetX, offsetY);
        }

        this.part.settings.pos.px = event.clientX;
        this.part.settings.pos.py = event.clientY;
        this.saveTextDrawPosition();
      } else if (this.part.type == 'sub') {
        
        const partSubSet = this.partSubSet(this.part);

        if (!partSubSet?.pos?.draggingCorner) return;
        
        const offsetX = event.clientX - partSubSet.pos.px;
        const offsetY = event.clientY - partSubSet.pos.py;
        console.log('onCornerMove x', offsetX)
        console.log('onCornerMove y', offsetY)
        // console.log('onCornerMove this.resizeDirection', this.resizeDirection)
        console.log('onCornerMove partSubSet.pos.resizeDirection', partSubSet.pos.resizeDirection)

        switch (partSubSet.pos.resizeDirection) {
          case 'topLeft':
            partSubSet.pos.x += offsetX;
            partSubSet.pos.y += offsetY;
            partSubSet.pos.width -= offsetX;
            partSubSet.pos.height -= offsetY;
            break;

          case 'topRight':
            partSubSet.pos.y += offsetY;
            partSubSet.pos.width += offsetX;
            partSubSet.pos.height -= offsetY;
            break;

          case 'bottomLeft':
            partSubSet.pos.x += offsetX;
            partSubSet.pos.width -= offsetX;
            partSubSet.pos.height += offsetY;
            break;

          case 'bottomRight':
            partSubSet.pos.width += offsetX;
            partSubSet.pos.height += offsetY;
            break;
        }
        this.updateMagnetLinesAndSnapOnResizeSub(partSubSet.pos.resizeDirection)

        partSubSet.pos.px = event.clientX;
        partSubSet.pos.py = event.clientY;

        this.saveSubPosition();
      }
  }

  @HostListener('window:mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    if (!this.part) return;

    if (this.part.type == 'text') {
      this.part.settings.pos.draggingCorner = false;
      this.part.settings.pos.draggingWindow = false;
      this.part.settings.pos.resizing = false;
    } else if (this.part.type == 'sub') {
      let partSubSet = this.partSubSet(this.part);
      partSubSet.pos.draggingWindow = false;
      partSubSet.pos.draggingCorner = false;
    }

  }


  ngOnChanges(changes: SimpleChanges): void {
    // console.log('ResizableDraggableBTextComponent changes', changes)

    if ((!!changes.project && !!changes.project.currentValue) || (changes.width && !!changes.width.currentValue && changes.width.previousValue != changes.width.currentValue) || (changes.height && !!changes.height.currentValue && changes.height.previousValue != changes.height.currentValue)) {
      if (this.part.type == 'text') {
        this.loadTextDrawPosition();
      } else {
        this.loadSubPosition();
      }
    }
  }
}